import { useAppSelector } from '@/core/global-store';

/** Platform owner shell (not a tenant company admin). */
export function useIsPlatformOwner(): boolean {
    const user = useAppSelector((state) => state.auth.me);
    return user?.data?.role === 'owner';
}
